<script setup>
import { ref } from 'vue';

const tab = ref({
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
})
const tab1 = ref(null)
const content1 = ref()
const content2 = ref()
const content3 = ref()
const content4 = ref()
const content5 = ref()
const content6 = ref()
const content7 = ref()
const changeTab = (i)=>{
  tab.value[i] = !tab.value[i]
}
const changeTab1 = (i)=>{
  if(tab1.value == i){
    return tab1.value = null
  }
  tab1.value = i
}

  const hasPrev = ref(false); // 是否可以滚动到上一项
  const hasNext = ref(true); // 是否可以滚动到下一项
  // 检查滚动位置，更新按钮状态
  const handleScroll = () => {
    if (content7.value) {
      const { scrollLeft, scrollWidth, clientWidth } = content7.value;
      hasPrev.value = scrollLeft > 0; // 如果 scrollLeft > 0，说明可以滚动到上一项
      hasNext.value = scrollLeft + clientWidth < scrollWidth; // 如果 scrollLeft + clientWidth < scrollWidth，说明可以滚动到下一项
    }
  };
  // 滚动到上一项
  const scrollPrev = () => {
    if (content7.value) {
      content7.value.scrollBy({
        left: -300, // 向左滚动一个容器的宽度
        behavior: 'smooth', // 平滑滚动
      });
    }
  };

  // 滚动到下一项
  const scrollNext = () => {
    if (content7.value) {
      content7.value.scrollBy({
        left: 300, // 向右滚动一个容器的宽度
        behavior: 'smooth', // 平滑滚动
      });
    }
  };
</script>
<template>
  <main
    class="mx-auto flex w-full max-w-[1392px] items-start justify-between gap-10 px-4 pb-4 mt-[60px] md:mt-[70px]"
  >
    <div class="w-full flex-1 md:max-w-[942px]">
      <div class="my-2 flex md:mb-2 md:mt-[10px]" aria-label="Breadcrumb">
        <ol class="inline-flex items-center">
          <li>
            <div class="flex items-center text-sm font-normal">
              <a
                href="https://upstox.com"
                class="whitespace-nowrap capitalize text-gray-accent3 hover:text-breadcrumb-link-hover"
                >home</a
              >
              <div class="px-2">
                <img
                  alt="breadcrumb indicator"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  class="max-w-[140px] cursor-pointer"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/arrow-right.svg"
                />
              </div>
            </div>
          </li>
          <li
            class="w-28 whitespace-nowrap pr-7 text-sm font-normal capitalize text-lighter-black sm:w-72"
          >
            gold rates
          </li>
        </ol>
      </div>
      <div class="flex h-full w-full flex-col">
        <div
          class="mt-2 flex flex-col justify-between gap-3 py-2 sm:flex-row sm:items-center sm:gap-2 md:mt-2 md:items-start md:gap-4 md:py-0"
        >
          <div class="flex shrink-0 items-center gap-2">
            <div class="flex flex-col gap-[2px]">
              <div
                role="button"
                tabindex="0"
                class="text-lg font-semibold leading-[26px] text-dark-1 sm:text-2xl sm:text-lighter-black"
              >
                <h1 class="inline">
                  Gold Rate Today in
                  <span
                    class="md:primary-underline underline-animation ml-1 cursor-pointer whitespace-nowrap py-1 font-semibold text-primary-base"
                    >India</span
                  >
                </h1>
                <!-- <img
                  alt="Chevron-down"
                  loading="lazy"
                  width="20"
                  height="20"
                  decoding="async"
                  data-nimg="1"
                  class="ml-1 inline cursor-pointer"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                /> -->
              </div>
              <span
                class="text-[12px] font-medium leading-4 text-dark-2 md:mt-1 md:text-sm md:font-normal"
                >Last updated on 28 Feb, 2025</span
              >
              <div class="hidden md:block">
                <div class="flex cursor-pointer items-center gap-1 md:mt-3">
                  <img
                    alt="share"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    src="/commodity-page-assets/images/share.svg"
                    style="color: transparent"
                  />
                  <div class="text-[12px] font-semibold text-main-2 md:text-sm">
                    Share
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex w-full items-start justify-between gap-2 md:flex-col md:items-end md:gap-3 md:pt-[3px]"
          >
            <div
              class="flex flex-col items-start gap-[4px] md:flex-col md:gap-3"
            >
              <div
                class="whitespace-nowrap text-base font-semibold leading-5 text-dark-6 md:text-[20px]"
              >
                ₹8,754.30/<span class="text-dark-6">GM</span>
              </div>
              <div
                class="text-[12px] font-semibold leading-5 md:text-[16px] md:font-medium lg:self-end text-live"
              >
                -44.00 (-0.50%)<!-- -->
              </div>
            </div>
            <div class="flex flex-col items-end gap-1">
              <div class="flex items-center gap-2">
                <button
                  class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 flex items-center justify-center rounded-[4px] px-2 py-[4px] text-[10px] leading-4 md:py-[6px] md:text-[12px]"
                >
                  24 Carat</button
                ><button
                  class="cursor-pointer disabled:cursor-not-allowed !border hover:bg-primary-light active:bg-primary-base2 active:text-white disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 flex items-center justify-center rounded-[4px] px-2 py-[4px] text-[10px] leading-4 md:py-[6px] md:text-[12px] !border-grey-7 font-medium text-black md:font-semibold !bg-white"
                >
                  22 Carat
                </button>
              </div>
              <div class="block md:hidden">
                <div class="flex cursor-pointer items-center gap-1 md:mt-3">
                  <img
                    alt="share"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    src="/commodity-page-assets/images/share.svg"
                    style="color: transparent"
                  />
                  <div class="text-[12px] font-semibold text-main-2 md:text-sm">
                    Share
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-4 md:my-0 md:py-6">
          <span
            class="block text-sm font-normal leading-5 text-lighter-black line-clamp-5 h-[60px] md:h-[60px]"
            >Gold has long been considered a reliable hedge against inflation,
            gaining favour among investors as a crucial investment. At Upstox
            (RKSV Securities Pvt Ltd), we provide gold prices in
            <!-- -->India<!-- -->
            for informational purposes, updated regularly from reputable
            jewellers in the country. Presently, the gold price in
            <!-- -->India<!-- -->
            stands at ₹<!-- -->8026.30<!-- -->
            per gram for 22 karat gold and ₹<!-- -->8754.30<!-- -->
            per gram for 24 karat gold, also known as 999 gold. <br /><br />As
            an investor or someone interested in buying gold, keeping an eye on
            the daily gold prices is crucial. The price of gold in<!-- -->
            <!-- -->India<!-- -->
            fluctuates daily due to various factors, impacting both buyers and
            sellers in the market.</span
          >
          <div
            class="cursor-pointer text-primary-base my-1 text-sm font-semibold"
          >
            <div
              class="cursor-pointer text-primary-base my-1 text-sm font-semibold"
            >
              Read More
            </div>
          </div>
          <div class="hidden opacity-0">
            <br /><br />
            <h2 class="font-semibold">
              Steps to Follow for Buying Gold in
              <!-- -->India
            </h2>
            <div class="my-2">
              <p class="text-sm">
                Buying gold in
                <!-- -->India<!-- -->
                involves several crucial steps:
              </p>
              <ol class="mx-4 list-decimal p-4 text-sm">
                <li>
                  Identify reputable sellers or jewellers known for quality and
                  authenticity.
                </li>
                <li>
                  Understand the prevailing gold rates, typically available from
                  reliable sources or through official platforms.
                </li>
                <li>
                  Determine the preferred form of gold, whether jewellery,
                  coins, or bars, based on personal preference or investment
                  goals.
                </li>
                <li>
                  Prioritise authenticity by ensuring proper certification or
                  hallmarking.
                </li>
                <li>
                  Conduct thorough research and due diligence before finalising
                  any purchase.
                </li>
                <li>
                  Familiarise yourself with the current market trends, varying
                  forms of gold available, and the quality standards to make an
                  informed and secure investment decision in the realm of gold
                  in<!-- -->India<!-- -->.
                </li>
              </ol>
            </div>
            <h2 class="font-semibold">
              Factors Determining Gold Prices in
              <!-- -->India
            </h2>
            <div class="my-2">
              <p class="text-sm">
                The price of gold in
                <!-- -->India<!-- -->
                is influenced by a number of factors, which collectively
                contribute to the daily fluctuations in gold prices:
              </p>
              <ol class="mx-4 list-decimal p-4 text-sm">
                <li>
                  Currency fluctuations: A depreciating rupee against the dollar
                  increases gold prices in
                  <!-- -->India<!-- -->.
                </li>
                <li>
                  International factors: Global economic conditions, volatile
                  policies, and the dollar's strength affect gold rates.
                </li>
                <li>
                  Global demand: Demand dynamics significantly impact the daily
                  gold rates in
                  <!-- -->India<!-- -->.
                </li>
                <li>
                  Interest rates: Interest rate movements, especially in the US,
                  inversely impact gold prices.
                </li>
                <li>
                  Government policies: Government measures may deter gold
                  consumption to curb rising prices and current account
                  deficits.
                </li>
                <li>
                  Price trends: High gold prices in
                  <!-- -->India<!-- -->
                  may discourage local consumption.
                </li>
              </ol>
            </div>
            <h2 class="font-semibold">
              Things to Know Before Investing in Gold in
              <!-- -->India
            </h2>
            <div class="my-2">
              <p class="text-sm">
                Before investing in gold in
                <!-- -->India<!-- -->, you need to consider the following
                factors:
              </p>
              <ol class="mx-4 list-decimal p-4 text-sm">
                <li>
                  Understand individual investment goals and the purpose behind
                  buying gold—whether as a hedge against inflation or portfolio
                  diversification.
                </li>
                <li>
                  Familiarise yourself with prevailing market trends, gold
                  pricing mechanisms, and forms of gold available.
                </li>
                <li>
                  Recognize the potential risks and costs associated with
                  physical gold, Gold ETFs, or Sovereign Gold Bonds (SGBs).
                </li>
                <li>
                  Consider factors such as liquidity, storage costs, and
                  taxation implications.
                </li>
                <li>
                  Conduct thorough research on reliable sellers, hallmarking,
                  and authenticity to make informed investment decisions.
                </li>
              </ol>
            </div>
            <p class="text-sm">
              Adequate knowledge of these aspects is vital to navigate the
              nuances of investing in gold in
              <!-- -->India<!-- -->.
            </p>
          </div>
        </div>
        <div class="mt-4 flex flex-col md:mt-0">
          <div class="flex flex-col gap-4 last:mt-8 md:gap-6">
            <h2 class="text-lg font-semibold">24K Gold Rate in India</h2>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="">
                  <tr>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Gram
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Today
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Yesterday
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="overflow-y-auto sm:max-h-80">
                <table
                  class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8"
                >
                  <tbody>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">1 Gram</td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,754.30
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -44.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,798.30
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -29.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">10 Gram</td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹87,543.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -440.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹87,983.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -290.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">
                        100 Gram
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,75,430.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -4,400.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,79,830.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -2,900.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4 last:mt-8 md:gap-6">
            <h2 class="text-lg font-semibold">22K Gold Rate in India</h2>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="">
                  <tr>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Gram
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Today
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Yesterday
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="overflow-y-auto sm:max-h-80">
                <table
                  class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8"
                >
                  <tbody>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">1 Gram</td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,026.30
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -40.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,066.30
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -27.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">10 Gram</td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹80,263.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -400.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹80,663.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -270.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td class="py-4 text-left text-lighter-black">
                        100 Gram
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,02,630.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -4,000.00 (-0.50%)
                        </div>
                      </td>
                      <td class="py-4 text-end font-medium text-lighter-black">
                        ₹8,06,630.00
                        <div
                          class="flex items-center justify-end text-sm text-live"
                        >
                          -2,700.00 (-0.33%)
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="gap-auto mt-flex-wrap flex items-center justify-between rounded-xl p-4 sm:gap-[3px] sm:rounded-2xl bg-gold-rose mt-8 sm:my-8"
        >
          <div
            class="flex basis-[194px] flex-col gap-1 sm:flex-1 sm:basis-[320px] sm:gap-[17px]"
          >
            <h2 class="text-base font-semibold text-dark-6 sm:text-2xl">
              Invest in Gold ETFs
            </h2>
            <div class="flex flex-col gap-2 sm:flex-row">
              <p
                class="text-[13px] font-medium leading-5 text-grey-8 sm:text-sm"
              >
                Explore investing in gold via Exchange Traded Funds (ETFs)
              </p>
              <a
                class="pointer text-[13px] font-bold leading-5 text-main-6 sm:text-sm"
                href="/etfs/nip-ind-etf-gold-bees-share-price/INF204KB17I5/"
                ><span
                  class="underline-position-from-front underline-decoration-thickness-auto underline-decoration-skip-ink underline-decoration-style-solid underline underline-offset-4"
                  >Invest now</span
                ><span> -&gt;</span></a
              >
            </div>
          </div>
          <div
            class="relative aspect-[124/100] shrink-0 basis-[102px] sm:aspect-[128/100] sm:basis-[133.119px]"
          >
            <img
              alt="gold-investment"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              class="h-full w-full object-cover"
              style="
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                color: transparent;
              "
              src="@/styles/img/commodity-page-assets/gold-brick.svg"
            />
          </div>
        </div>
        <div
          class="mb-[48px] mt-12 flex flex-col gap-4 md:mb-8 md:mt-0 md:border-b md:pb-8"
        >
          <h2 class="text-lg font-semibold">Gold Investment in India</h2>
          <div
            class="mb-4 flex flex-col gap-4 sm:flex-row sm:flex justify-start sm:gap-1"
          >
            <div
              class="flex justify-between gap-1 border-b border-b-gray-accent2 pb-4 sm:flex-col sm:border-none sm:pb-0"
            >
              <div class="text-sm font-normal leading-5 mr-10 text-gray-dark">
                24K Gold / 10 Grams
              </div>
              <div class="text-sm leading-5 font-medium md:font-medium">
                ₹87,543.00
              </div>
            </div>
            <div class="flex justify-between gap-1 pb-4 sm:flex-col sm:pb-0">
              <div class="text-sm font-normal leading-5 text-gray-dark">
                22K Gold / 10 Grams
              </div>
              <div
                class="text-sm leading-5 font-medium text-dark-6 md:font-medium"
              >
                ₹80,263.00
              </div>
            </div>
          </div>
          <div>
            <span
              class="block text-sm font-normal leading-5 text-lighter-black line-clamp-5 h-[60px] md:h-[60px]"
              >Gold has long been considered a reliable hedge against inflation,
              gaining favour among investors as a crucial investment. At Upstox
              (RKSV Securities Pvt Ltd), we provide gold prices in
              <!-- -->India<!-- -->
              for informational purposes, updated regularly from reputable
              jewellers in the country. Presently, the gold price in
              <!-- -->India<!-- -->
              stands at ₹<!-- -->8026.3<!-- -->
              per gram for 22 karat gold and ₹<!-- -->8754.3<!-- -->
              per gram for 24 karat gold, also known as 999 gold. <br /><br />As
              an investor or someone interested in buying gold, keeping an eye
              on the daily gold prices is crucial. The price of gold in<!-- -->
              <!-- -->India<!-- -->
              fluctuates daily due to various factors, impacting both buyers and
              sellers in the market.</span
            >
            <div
              class="cursor-pointer text-primary-base my-1 text-sm font-semibold"
            >
              <div
                class="cursor-pointer text-primary-base my-1 text-sm font-semibold"
              >
                Read More
              </div>
            </div>
            <div class="hidden opacity-0">
              <br /><br />
              <h2 class="font-semibold">
                Difference in Physical Gold, Gold ETFs and Sovereign Gold Bonds
              </h2>
              <span
                class="my-2 inline-block text-sm font-normal leading-5 text-lighter-black"
                >Investors can choose between physical gold, Gold Exchange
                Traded Funds (ETFs), and Sovereign Gold Bonds (SGBs). Each has
                its advantages concerning liquidity, safety, and ease of
                investment. Physical gold involves owning tangible gold in the
                form of bars, coins, or jewellery, allowing direct possession.
                On the other hand, Gold Exchange Traded Funds (ETFs) are traded
                on stock exchanges, representing fractional gold ownership. They
                offer liquidity and convenience without physical possession.
                Meanwhile, Sovereign Gold Bonds (SGBs), issued by the
                government, are a secure investment offering interest and
                capital gains. Understanding these options—physical gold for
                ownership, ETFs for convenience, and SGBs for security—empowers
                investors to choose based on preferences, liquidity needs, and
                risk appetite, forming a diversified gold investment portfolio
                in
                <!-- -->India<!-- -->.</span
              ><br /><br />
              <h2 class="font-semibold">
                Understanding 18K, 22K &amp; 24K Gold
              </h2>
              <div class="my-2">
                <p class="text-sm">
                  Understanding the differences between various gold purity
                  levels—18K, 22K, and 24K—helps make informed choices when
                  purchasing gold:
                </p>
                <ul class="mx-4 list-disc p-4 text-sm">
                  <li>
                    24K Gold: Renowned for its purity, it is 99.9% pure gold,
                    making it the highest in gold content. Its softness makes it
                    unsuitable for crafting jewellery without alloying with
                    other metals.
                  </li>
                  <li>
                    22K Gold: Comprising 91.6% gold and 8.3% alloy metals, 22K
                    gold is durable and extensively used in jewellery making.
                    Its vibrant hue and strength make it ideal for intricate
                    designs.
                  </li>
                  <li>
                    18K Gold: Containing 75% gold and 25% alloy metals, it
                    strikes a balance between durability and purity. Slightly
                    less expensive than higher karat gold, it's preferred for
                    modern designs and affordability.
                  </li>
                  <li>
                    Consider factors such as liquidity, storage costs, and
                    taxation implications.
                  </li>
                  <li>
                    Conduct thorough research on reliable sellers, hallmarking,
                    and authenticity to make informed investment decisions.
                  </li>
                </ul>
                <p class="mb-4 text-sm">
                  Purity Variation: 24K gold is pure, softer, and more prone to
                  scratches, while 18K and 22K are alloyed for enhanced
                  strength, making them suitable for intricate jewellery.
                </p>
                <p class="mb-4 text-sm">
                  Colour and Appearance: Higher karat gold like 24K appears more
                  vibrant due to its pure gold content, while lower karat gold
                  exhibits a paler hue due to alloying metals.
                </p>
                <p class="mb-4 text-sm">
                  Durability: 18K and 22K gold are more durable due to alloy
                  additions, making them preferable for jewellery that is worn
                  everyday.
                </p>
                <p class="text-sm">
                  Understanding these differences assists buyers in choosing
                  gold jewellery that aligns with their preferences for purity,
                  durability, and design, ensuring a well-informed and
                  satisfactory purchase of gold in
                  <!-- -->India<!-- -->.
                </p>
              </div>
              <br />
              <h2 class="font-semibold">
                Is Gold Investment a Safe Option in
                <!-- -->India<!-- -->?
              </h2>
              <div class="my-2">
                <p class="text-sm">
                  Investing in gold has long been considered a safe haven and an
                  integral part of
                  <!-- -->India<!-- -->'s financial culture. Here's why:
                </p>
                <ul class="mx-4 list-disc p-4 text-sm">
                  <li>
                    Historical Stability: Gold holds historical significance as
                    a stable asset, protecting against economic uncertainties,
                    market fluctuations, and inflation, thus safeguarding
                    wealth.
                  </li>
                  <li>
                    Diversification: Adding gold to an investment portfolio
                    diversifies risk, balancing the impact of market volatility
                    in stocks, bonds, or real estate.
                  </li>
                  <li>
                    Inflation Hedge: Gold often retains its value during
                    inflationary periods, preserving purchasing power.
                  </li>
                  <li>
                    Cultural Relevance: In
                    <!-- -->India<!-- -->, gold is deeply ingrained in
                    traditions and ceremonies, ensuring constant demand and
                    cultural value.
                  </li>
                  <li>
                    Long-Term Store of Value: Gold generally maintains its worth
                    over extended periods, offering a sense of security to
                    investors.
                  </li>
                </ul>
                <p class="mb-4 text-sm">
                  Despite its advantages, gold investment isn't devoid of risks.
                  Gold prices fluctuate due to market dynamics and geopolitical
                  factors, impacting its short-term performance. Furthermore, it
                  doesn't generate income or dividends like other investments,
                  and storage costs can also be a consideration.
                </p>
                <p class="mb-4 text-sm">
                  Considering the balance between safety and potential risks,
                  incorporating gold into an investment portfolio can enhance
                  stability. However, it's advisable to approach gold investment
                  as part of a diversified strategy, assessing personal
                  financial goals and risk tolerance before making decisions.
                </p>
              </div>
              <br />
              <h2 class="font-semibold">
                Understanding KDM Gold in
                <!-- -->India
              </h2>
              <div class="my-2">
                <p class="text-sm">
                  KDM gold is a type of gold that consists of 92% gold and an 8%
                  alloy of cadmium, aimed to ensure exceptional purity. However,
                  this blend posed significant health risks to craftsmen. Due to
                  the health hazards associated with cadmium, the Bureau of
                  Indian Standards (BIS) has prohibited its use in jewellery
                  making. Today, KDM gold substitutes cadmium with advanced
                  solder metals like zinc and other alloys, maintaining the
                  gold's purity without compromising the health of craftsmen.
                  This change has ensured that KDM gold eliminates the health
                  hazards, while retaining its purity standards.
                </p>
              </div>
              <br />
              <h2 class="font-semibold">
                Verifying Hallmarked Gold in
                <!-- -->India
              </h2>
              <div class="my-2">
                <p class="text-sm">
                  Verifying hallmarked gold in
                  <!-- -->India<!-- -->
                  is crucial to ensure authenticity and purity. Here are steps
                  to verify:
                </p>
                <ol class="mx-4 list-decimal p-4 text-sm">
                  <li>
                    Check BIS Mark: The Bureau of Indian Standards (BIS) mark
                    authenticates the gold's purity. Look for the BIS logo, as
                    it confirms that the gold adheres to national standards.
                  </li>
                  <li>
                    Seek Certification: Obtain a Certificate of Authenticity
                    from the jeweller, confirming the hallmark details. This
                    certificate validates the purity and authenticity of the
                    gold.
                  </li>
                  <li>
                    Use Magnifying Tools: Employ a magnifying glass to closely
                    inspect the hallmark. This aids in identifying the small
                    markings, ensuring accuracy in purity determination.
                  </li>
                  <li>
                    Buy from Trusted Jewellers: Purchase gold from trusted and
                    reputable jewellers who follow ethical practices and provide
                    genuine hallmarked jewellery.
                  </li>
                </ol>
                <p class="mb-4 text-sm">
                  Verifying hallmarked gold is essential to ensure you're
                  purchasing authentic, high-quality gold jewellery. Taking
                  these steps helps in safeguarding against counterfeit products
                  and assures you of the gold's purity and value.
                </p>
              </div>
              <br />
              <h2 class="font-semibold">
                Understanding 916 Hallmarked Gold in
                <!-- -->India
              </h2>
              <div class="my-2">
                <p class="text-sm">
                  In
                  <!-- -->India<!-- -->, 916 hallmarked gold signifies a gold
                  alloy with 91.6% pure gold content, also known as 22 karat
                  gold. The term "916" reflects the gold's purity level, wherein
                  out of a total of 1000 parts, 916 parts consist of pure gold,
                  while the remaining 84 parts comprise other metals such as
                  silver, copper, or zinc to form the alloy.
                </p>
                <p class="mb-4 text-sm">
                  This hallmarking system, regulated by the Bureau of Indian
                  Standards (BIS), assures buyers of the gold's quality and
                  purity, providing credibility and authenticity. Gold marked as
                  916 is widely accepted and preferred for crafting jewellery
                  due to its durability, suitable for intricate designs and
                  patterns. It maintains a balance between purity and strength,
                  making it a popular choice among consumers seeking traditional
                  and culturally significant gold ornaments in<!-- -->
                  <!-- -->India<!-- -->. Choosing 916 hallmarked gold ensures
                  buyers of a standardised quality level, making it a reliable
                  option in the country's gold market.
                </p>
              </div>
              <br />
              <h2 class="font-semibold">Summary</h2>
              <div class="my-2">
                <p class="text-sm">
                  Investing in gold in
                  <!-- -->India<!-- -->
                  involves various aspects, from understanding its pricing and
                  forms to recognising purity standards. Considering these
                  factors is crucial for anyone interested in entering the gold
                  market.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-12">
          <div class="flex flex-col gap-5">
            <div class="flex items-center justify-between gap-2">
              <h2 class="text-lg font-semibold">Gold Rate Analysis</h2>
              <div
                class="hidden flex h-10 cursor-pointer items-center justify-between gap-2 rounded-lg border border-gray-accent4 px-4 py-2 text-sm text-gray-accent3"
              >
                Feb'25<img
                  alt="arrow"
                  loading="lazy"
                  width="16"
                  height="16"
                  decoding="async"
                  data-nimg="1"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                  style="color: transparent"
                />
              </div>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="">
                  <tr>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      Gold Rate
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      24K Gold
                    </th>
                    <th
                      class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                    >
                      22K Gold
                    </th>
                  </tr>
                </thead>
              </table>
              <div class="overflow-y-auto sm:max-h-80">
                <table
                  class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8"
                >
                  <tbody>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Feb 1
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹84,513.00
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹77,483.00
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Feb 28
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹87,543.00
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹80,263.00
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Highest in Feb
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹88,273.00
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹80,933.00
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Lowest in Feb
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹84,213.00
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        ₹77,213.00
                      </td>
                    </tr>
                    <tr
                      class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                    >
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Overall performance
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Rising
                      </td>
                      <td
                        class="py-4 text-right font-normal text-lighter-black first:text-left first:font-normal"
                      >
                        Rising
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <h2 class="text-lg font-semibold">Month Wise Gold Rate<!-- --></h2>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(1)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Feb 2025</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[1]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[1]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Feb 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹84,513.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Feb 28
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹87,543.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Feb
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹88,273.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Feb
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹84,213.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Rising
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(2)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Jan 2025</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[2]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[2]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Jan 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹77,723.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Jan 31
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹83,203.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Jan
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹83,203.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Jan
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹77,723.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Rising
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(3)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Dec 2024</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[3]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[3]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Dec 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹78,173.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Dec 31
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹78,183.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Dec
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹79,653.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Dec
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹76,963.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Rising
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(4)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Nov 2024</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[4]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[4]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Nov 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹81,513.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Nov 30
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹78,293.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Nov
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹81,513.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Nov
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹75,813.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Falling
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(5)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Oct 2024</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[5]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[5]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Oct 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹77,403.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Oct 31
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹81,343.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Oct
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹81,343.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Oct
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹76,803.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Rising
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="overflow-hidden rounded-lg border border-gray-light">
              <table
                class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
              >
                <thead class="cursor-pointer bg-gray-light" @click="changeTab(6)">
                  <tr class="">
                    <th
                      class="py-4 text-right text-sm font-semibold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm md:font-bold"
                    >
                      <h3>Gold Price in India, Sep 2024</h3>
                    </th>
                    <th class="py-4 text-gray-dark">
                      <img
                        alt="accordian"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="ml-auto"
                        :class="[tab[6]?'rotate-180':'']"
                        style="color: transparent"
                        src="@/styles/img/commodity-page-assets/chevron-down.svg"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody :class="[tab[6]?'table-row-group':'hidden']">
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-semibold text-gray-dark"
                    >
                      Rate
                    </td>
                    <td
                      class="py-4 text-end text-sm font-semibold text-gray-dark"
                    >
                      24K Gold / (10GM)
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Sep 1
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹73,901.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Sep 30
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹77,563.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Highest in Sep
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹77,633.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Lowest in Sep
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      ₹72,638.00
                    </td>
                  </tr>
                  <tr
                    class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                  >
                    <td
                      class="py-4 text-left text-sm font-normal text-lighter-black"
                    >
                      Overall performance
                    </td>
                    <td
                      class="py-4 text-end text-sm font-normal text-lighter-black"
                    >
                      Rising
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="inline-flex h-5 items-start justify-start">
              <div
                class="inline-flex shrink grow basis-0 flex-col items-start justify-start"
              >
                <div
                  class="cursor-pointer text-sm font-semibold leading-tight text-purple-link"
                >
                  View More
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <h2 class="text-lg font-semibold">Gold Rates Over Last 10 Days</h2>
            <div class="block false">
              <div class="overflow-hidden rounded-lg border border-gray-light">
                <table
                  class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
                >
                  <thead class="">
                    <tr>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        Date
                      </th>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        24K Gold
                      </th>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        22K Gold
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="overflow-y-auto sm:max-h-80">
                  <table
                    class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8"
                  >
                    <tbody>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          28 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,543.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.50%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,263.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.50%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          27 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,983.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.33%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,663.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.33%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          26 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹88,273.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.25%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,933.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.26%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          25 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹88,053.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.14%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,723.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.14%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          24 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,933.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.01%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,613.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.01%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          23 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,943.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.43%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,623.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.39%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          22 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,563.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.75%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,313.00
                          <div class="text-sm leading-5 text-live font-medium">
                            -0.70%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          21 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹88,223.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.44%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,883.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.50%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          20 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,833.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.80%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,483.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.75%
                          </div>
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          19 Feb 2025
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,133.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.38%
                          </div>
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹79,883.00
                          <div
                            class="text-sm leading-5 text-green-base font-medium"
                          >
                            0.38%
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-5">
            <h2 class="text-lg font-semibold">Gold Rates in Major Cities</h2>
            <div class="block sm:max-h-[420px] sm:overflow-auto">
              <div class="overflow-hidden rounded-lg border border-gray-light">
                <table
                  class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8 [&amp;_th]:px-3 sm:[&amp;_th]:px-8"
                >
                  <thead class="sticky top-0 z-10">
                    <tr>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        City
                      </th>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        24K Gold
                      </th>
                      <th
                        class="bg-gray-light !py-4 text-right text-sm font-bold text-gray-dark first:rounded-tl-sm first:text-left last:rounded-tr-sm"
                      >
                        22K Gold
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="overflow-y-auto sm:max-h-80">
                  <table
                    class="w-full table-fixed border border-gray-light [&amp;_td]:px-3 sm:[&amp;_td]:px-8"
                  >
                    <tbody>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-bangalore/"
                            >Bangalore</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,552.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,272.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-bhubaneswar/"
                            >Bhubaneswar</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,390.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,110.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-chennai/"
                            >Chennai</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,536.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,256.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-coimbatore/"
                            >Coimbatore</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,536.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,256.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-delhi/"
                            >Delhi</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,543.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,263.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-hyderabad/"
                            >Hyderabad</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,399.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,119.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-kolkata/"
                            >Kolkata</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,395.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,115.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-mumbai/"
                            >Mumbai</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,397.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,117.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-mysore/"
                            >Mysore</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,552.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,272.00
                        </td>
                      </tr>
                      <tr
                        class="border-b border-l border-r border-gray-light border-b-gray-accent2 text-sm last:border-b-gray-light"
                      >
                        <td class="py-4 text-left text-lighter-black">
                          <a
                            href="/gold-rates/gold-rates-in-pune/"
                            >Pune</a
                          >
                        </td>
                        <td
                          class="max-w-fit py-4 text-end font-normal text-lighter-black"
                        >
                          ₹87,397.00
                        </td>
                        <td
                          class="py-4 text-end font-normal text-lighter-black"
                        >
                          ₹80,117.00
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-1 my-10">
          <h2
            class="mb-6 mt-2 text-lg font-semibold text-lighter-black sm:text-[18px]"
          >
            Frequently Asked Questions
          </h2>
          <div class="flex flex-col gap-1">
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                role="button"
                 @click="changeTab1(1)"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  How many grams of gold are present in one 'tola' of gold?
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===1?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div ref="content1"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"
                :style="{height: tab1==1?content1.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    <!-- -->One tola of gold amounts to approximately 11.66
                    grams. This unit of measurement is historically significant
                    as it was used to weigh precious metals. Although the
                    standard equation is 11.7 grams, most Indian jewellers round
                    off this figure to 10 grams, to simplify the process of
                    transactions.<!-- -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                @click="changeTab1(2)"
                role="button"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  What is the difference between 22k and 24K gold?
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===2?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div
                ref="content2"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"
                :style="{height: tab1==2?content2.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    <!-- -->The main difference between 22K and 24K gold is in
                    its purity and durability. 24K gold contains 99.9% of gold
                    whereas 22K gold contains 91.67% of gold mixed with other
                    metals like copper. While 24K gold is pure, it is also too
                    soft to be used in daily life. Which is why copper is added
                    to 22K gold while making jewellery to make it more durable
                    for daily wear. It is a popular choice as it still has a
                    high content of gold but is also durable.
                    <!-- -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                role="button"
                 @click="changeTab1(3)"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  How is the gold rate in India determined?
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===3?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div ref="content3"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"
                :style="{height: tab1==3?content3.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    <!-- -->The gold rate in India is calculated by a multitude
                    of factors. International prices are an important factor, as
                    gold is traded in US dollars. This means that changes in the
                    dollar-rupee exchange rate directly affects local prices. On
                    top of that, import duties and taxes like GST are added to
                    the final price. Moreover, local demand and supply, such as
                    a higher demand during festival seasons, also influences the
                    rates. All of these factors can bring some volatility in the
                    final gold rate.
                    <!-- -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                role="button"
                @click="changeTab1(4)"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  What do the terms hallmark, 916, and KDM in gold jewelry mean?
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===4?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div ref="content4"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"                
                :style="{height: tab1==4?content4.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    <!-- -->Gold jewelry in India is marked with hallmark, 916,
                    and KDM trademarks. These terms provide information about
                    the characteristics of the gold jewelry. The hallmark gold
                    is certified by the Bureau of Indian Standards (BIS) and is
                    purity certified based on specific quality standards. 916 is
                    22K gold, made of 91.6% pure gold, showing its durability.
                    In contrast, KDM (Kadmium gold) is an alloy of 92% gold and
                    8% cadmium, traditionally used for intricate designs but
                    banned due to health concerns about cadmium exposure.<!-- -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                role="button"
                 @click="changeTab1(5)"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  What should I look out for when buying gold in India?
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===5?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div ref="content5"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"
                :style="{height: tab1==5?content5.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    When buying gold in India, you should pay attention to the
                    following key factors:
                    <ul>
                      <li>
                        1. Hallmark: Check for the hallmark certificate, as it
                        guarantees purity, either in the form of 22K (916) gold
                        or 24K (999) gold.
                      </li>
                      <li>
                        2. Making Charges: Inquire about the additional charges
                        levied by the store for craftsmanship as it can vary
                        widely between jewellers.
                      </li>
                      <li>
                        3. Seller's Reputation: Buy from certified jewellers
                        with a good reputation for quality and fair pricing.
                      </li>
                      <li>
                        4. Live Rates: Keep yourself updated with live market
                        rates in order to make better decisions.
                      </li>
                      <li>
                        5. Buyback: Check the jeweller's buyback terms for
                        future resale value.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col border-b border-b-gray-accent2 py-4 last:border-none"
            >
              <header
                 @click="changeTab1(6)"
                role="button"
                class="flex cursor-pointer flex-row items-start justify-between gap-2"
              >
                <h3
                  class="text-sm font-semibold text-lighter-black sm:text-base"
                >
                  How can I check the purity of gold in India
                </h3>
                <img
                  alt="accordian"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  :class="[tab1===6?'rotate-180':'']"
                  style="color: transparent"
                  src="@/styles/img/commodity-page-assets/chevron-down.svg"
                />
              </header>
              <div ref="content6"
                class="overflow-y-hidden text-sm text-gray-dark transition-all"
                :style="{height: tab1==6?content6.scrollHeight+'px':0}"
              >
                <div class="pt-4">
                  <div>
                    To determine the purity of gold in India, use the following
                    methods:
                    <ul>
                      <li>
                        1. Hallmark: Check for the BIS hallmark that
                        authenticates that the gold meets standard purity
                        levels. This stamp shows you the karatage of the gold
                        and ensures buyers' confidence.
                      </li>
                      <li>
                        2. Magnet Test: Gold is not magnetic, so expose it to a
                        magnet. If it is attracted towards the magnet, it's not
                        gold.
                      </li>
                      <li>
                        3. Float Test: Put your gold in water. Pure gold will
                        sink, whereas other metals might just float or hover.
                        These methods can help assure you that you're buying
                        pure gold.
                      </li>
                      <ul></ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-0 md:mb-[3.75rem] md:mt-2" id="News" data-section="true">
          <div class="flex w-full items-center justify-between cursor-pointer" @click="changeTab1(7)">
            <div
              class="flex gap-1 text-xl font-semibold leading-7 text-lighter-black"              
            >
              <h2>What's in news?</h2>
            </div>
            <img
              alt="arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="mb-4 cursor-pointer"
              :class="[tab1===7?'rotate-180':'']"
              style="color: transparent"
              src="@/styles/img/commodity-page-assets/chevron-down.svg"
            />
          </div>
          <div class="flex flex-col py-4">
            <div ref="content7" :style="{height: tab1==7?content7.scrollHeight+'px':0}" @scroll="handleScroll"
              class="no-scrollbar mx-[-16px] flex snap-x snap-mandatory gap-3 overflow-x-scroll sm:mx-0 md:scroll-px-0 md:px-0"
            >
              <a
                target="_blank"
                class="pl-4 sm:pl-0"
                href="/news/market-news/commodities/gold-and-silver-price-on-february-27-gold-rate-slips-on-weak-global-trends-check-prices-in-your-city/article-148747/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->28d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 27: Gold rate slips on
                    weak global trends; check prices in your city
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-prices-on-february-25-domestic-gold-rate-rise-amid-geopolitical-risk-and-trade-war-concern/article-148176/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->3d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver prices on February 25: Domestic gold rate
                    rise amid geopolitical risk and trade war concern
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-24-24k-gold-rate-around-87-760-in-mumbai-check-prices-in-your-city/article-147868/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->4d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 24: 24k gold rate around
                    ₹87,760 in Mumbai; check prices in your city
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-21-gold-rate-rallies-to-new-lifetime-high-on-firm-global-cues/article-147439/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->7d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 21: Gold rate rallies to
                    new lifetime high on firm global cues
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-20-gold-rises-for-4th-day-to-hit-all-time-high/article-147107/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->8d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 20: Gold rises for 4th day
                    to hit all-time high
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-19-gold-prices-advance-on-firm-global-trends-silver-slips/article-146775/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->9d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 19: Gold prices advance on
                    firm global trends, silver slips
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-18-gold-prices-rebound-on-us-trade-policy-uncertainty/article-146425/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->10d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 18: Gold prices rebound on
                    US trade policy uncertainty
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-17-gold-slips-in-early-trade-on-easing-geopolitical-worries/article-146134/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->11d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 17: Gold slips in early
                    trade on easing geopolitical worries
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-14-gold-rate-above-87-000-10-gram-as-us-dollar-slides-1/article-145780/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->14d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 14: Gold rate above
                    ₹87,000/10 gram as US dollar slides
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-13-24k-gold-rate-around-86-810-in-delhi-check-prices-in-your-city-1/article-145577/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->15d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 13: 24k gold rate around
                    ₹86,810 in Delhi; check prices in your city
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-12-gold-rally-continues-amid-trade-war-concerns-weak-dollar/article-145420/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->16d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 12: Gold rally continues
                    amid trade war concerns, weak dollar
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-today-february-11-gold-hits-fresh-record-high-on-firm-global-trends/article-145162/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->17d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and Silver Price Today (February 11): Gold hits fresh
                    record high on firm global trends
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-today-february-10-gold-slips-from-record-high-silver-drops-100/article-144892/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->18d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and Silver price today (February 10): Gold slips from
                    record high, silver drops ₹100
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-surges-over-2-to-surpass-86-000-per-10-grams-this-week/article-144720/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->21d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold surges over 2% to surpass ₹86,000 per 10 grams this
                    week
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-7-gold-rate-rise-for-4th-straight-day-amid-rising-demand/article-144585/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->21d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 7: Gold rate rise for 4th
                    consecutive day amid rising demand
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-6-gold-rate-above-86-000-per-10-gram-amid-strong-local-demand/article-144317/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->22d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 6: Gold rate above ₹86,000
                    per 10 gram amid strong local demand
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-today-february-5-gold-rallies-to-all-time-high-on-weak-dollar/article-144177/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->23d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and Silver price on February 5: Gold rallies to
                    all-time high on weak dollar
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-4-gold-rate-above-84-000-per-10-gram-in-major-cities-check-details/article-144041/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->24d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 4: Gold rate above ₹84,000
                    per 10 gram in major cities; check details
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-3-gold-rate-slips-from-record-high-as-us-dollar-index-rebounds/article-143878/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->25d
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 3: Gold rate slips from
                    record high as US dollar index rebounds
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-february-1-gold-rate-above-84-300-in-major-cities-amid-us-tariff-threats/article-143573/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on February 1: Gold rate above ₹84,300
                    in major cities amid US tariff threats
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-january-31-gold-rate-surge-to-fresh-all-time-high-amid-trade-war-fear/article-143322/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on January 31: Gold rate surge to
                    fresh all-time high amid trade war fear
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-january-30-gold-rate-hit-fresh-record-high-on-weak-dollar/article-143139/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on January 30: Gold rate hit fresh
                    record high on weak dollar
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-january-29-precious-metals-trade-lower-for-third-straight-day-ahead-of-us-fed-meeting-outcome/article-142980/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on January 29: Precious metals trade
                    lower for third straight day ahead of US Fed meeting outcome
                  </p>
                </div></a
              ><a
                target="_blank"
                class=""
                href="/news/market-news/commodities/gold-and-silver-price-on-january-28-precious-metals-trade-lower-amid-fear-of-global-trade-war/article-142712/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on January 28: Precious metals trade
                    lower amid fear of global trade war
                  </p>
                </div></a
              ><a
                target="_blank"
                class="pr-4 sm:pr-0"
                href="/news/market-news/commodities/gold-and-silver-price-on-january-27-24k-gold-rate-around-82-560-in-delhi-check-prices-in-your-city/article-142448/"
                ><div
                  class="h-full w-[271px] cursor-pointer rounded-lg bg-gray-light p-4"
                >
                  <div class="flex items-center gap-2">
                    <img
                      alt="source logo"
                      loading="lazy"
                      width="32"
                      height="32"
                      decoding="async"
                      data-nimg="1"
                      class="rounded-full"
                      style="color: transparent"
                      src="https://assets.upstox.com/content/assets/images/logos/UPSTOX/UPSTOX.png"
                    />
                    <p class="text-sm font-medium leading-5 text-gray-accent3">
                      Upstox<!-- -->
                      •
                      <!-- -->a month
                    </p>
                  </div>
                  <p
                    class="light-black pb-2 pt-4 text-[13px] font-normal leading-5"
                  >
                    Gold and silver price on January 27: 24k gold rate around
                    ₹82,560 in Delhi; check prices in your city
                  </p>
                </div></a
              >
            </div>
          </div>
          <div class="ml-auto xs:hidden gap-4 md:flex md:justify-end" v-if="tab1==7">
            <div
              class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-dark p-1"
              :class="[!hasPrev?'opacity-30 cursor-not-allowed':'cursor-pointer']"
              @click="scrollPrev"
            >
              <img
                alt="left"
                fetchpriority="high"
                width="12"
                height="12"
                decoding="async"
                data-nimg="1"
                class="rotate-180"
                style="color: transparent"
                src="@/styles/img/commodity-page-assets/forward-arrow.svg"
              />
            </div>
            <div
              class="flex h-8 w-8 items-center justify-center rounded-full border border-gray-dark p-1"
              :class="[!hasNext?'opacity-30 cursor-not-allowed':'cursor-pointer']"
              @click="scrollNext"
            >
              <img
                alt="right"
                fetchpriority="high"
                width="12"
                height="12"
                decoding="async"
                data-nimg="1"
                style="color: transparent"
                src="@/styles/img/commodity-page-assets/forward-arrow.svg"
              />
            </div>
          </div>
        </div>
        <div
          class="fixed bottom-[-1px] left-0 z-[11] h-auto w-full translate-y-0 rounded-t-2xl bg-white shadow-[0px_-4px_10px_0px_rgba(0,0,0,0.10)] transition-all duration-500 md:translate-y-full"
        >
          <a
            class="m-4 flex h-10 items-center justify-center rounded-[24px] bg-main-2 px-4 py-2 text-center text-sm font-bold text-white"
            href="/etfs/nip-ind-etf-gold-bees-share-price/INF204KB17I5/"
            >Invest in
            <!-- -->Gold<!-- -->
            ETF</a
          >
        </div>
      </div>
    </div>
    <div class="mt-4 xs:hidden md:flex md:flex-col relative top-0">
      <div
        class="flex flex-col md:rounded-2xl md:border border-gray-accent2 py-3 px-4 md:p-6 shadow-lg"
      >
        <div class="flex flex-col gap-3">
          <div>
            <h2
              class="text-2xl font-bold not-italic leading-8 tracking-[-0.24px] text-primary-medium"
            >
              Invest in Gold Funds
            </h2>
            <hr class="my-3" />
            <div class="flex flex-row items-center justify-start gap-4">
              <img
                alt="Gold ETFs"
                loading="lazy"
                width="20"
                height="20"
                decoding="async"
                data-nimg="1"
                class="flex h-6 w-6 items-center justify-center rounded-full bg-gold-background p-1"
                style="color: transparent"
                src="@/styles/img/commodity-page-assets/ETF.svg"
              /><span class="flex flex-col gap-1"
                ><span class="text-sm text-lighter-black">Gold ETFs</span
                ><span class="text-xs text-gray-dark"
                  >No entry or exit loads</span
                ></span
              >
            </div>
            <br class="my-2" />
            <div class="flex flex-row items-center justify-start gap-4">
              <img
                alt="Gold Mutual Funds"
                loading="lazy"
                width="20"
                height="20"
                decoding="async"
                data-nimg="1"
                class="flex h-6 w-6 items-center justify-center rounded-full bg-gold-background p-1"
                style="color: transparent"
                src="@/styles/img/commodity-page-assets/MF.svg"
              /><span class="flex flex-col gap-1"
                ><span class="text-sm text-lighter-black"
                  >Gold Mutual Funds</span
                ><span class="text-xs text-gray-dark"
                  >0% commission on direct funds</span
                ></span
              >
            </div>
            <hr class="my-4" />
            <h3 class="text-sm font-semibold leading-5 text-light-black">
              Enter your mobile number to continue
            </h3>
          </div>
          <div
            class="flex flex-row items-center gap-2 md:flex-col md:items-start"
          >
            <div
              class="relative flex flex-1 items-center text-base leading-6 md:w-full"
            >
              <span class="absolute left-2 top-2 font-semibold text-gray-dark"
                >+91</span
              ><input
                class="y-2 h-10 w-full gap-3 !rounded-full border-primary-medium !bg-gray-light !px-4 !py-2 !pl-11 outline-none focus:border"
                id="open-demat-account-number"
                value=""
              />
            </div>
            <div class="text-xs text-danger md:block hidden">
              Enter a 10-digit valid mobile number.
            </div>
            <button
              class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark2 disabled:bg-primary-base/50 rounded-full h-10 text-sm font-bold leading-6 md:w-full"
              disabled=""
            >
              <span class="font-semibold">Invest in Gold ETF</span>
            </button>
          </div>
          <p
            class="hidden text-[10px] font-medium not-italic leading-4 text-gray-dark2 md:block"
          >
            By signing up you agree to our<a
              class="ml-1 font-bold underline"
              target="_blank"
              href="/terms-of-use-and-privacy-policy/"
              >Terms and Conditions</a
            >
          </p>
        </div>
      </div>
      <div class="flex flex-col py-4">
        <div
          class="flex w-full items-center border-b border-b-gray-accent2 py-4 text-sm font-semibold text-gray-dark"
        >
          Quick links
        </div>
        <ul>
          <li class="border-b border-b-gray-accent2 py-4 last:border-none">
            <a
              class="flex w-full justify-between text-gray-accent3"
              href="/mutual-funds/explore/invest-in-gold-funds"
              target="_blank"
              ><div
                class="text-sm leading-5 py-1 font-medium text-gray-dark underline-animation gray-underline"
              >
                Invest in Gold Mutual Funds
              </div></a
            >
          </li>
          <li class="border-b border-b-gray-accent2 py-4 last:border-none">
            <a
              class="flex w-full justify-between text-gray-accent3"
              href="/stocks/nip-ind-etf-gold-bees-share-price/INF204KB17I5/"
              target="_blank"
              ><div
                class="text-sm leading-5 py-1 font-medium text-gray-dark underline-animation gray-underline"
              >
                Invest in Gold ETFs
              </div></a
            >
          </li>
        </ul>
      </div>
      <div class="inline-flex flex-col items-start justify-start py-4">
        <div
          class="inline-flex items-center justify-start gap-4 self-stretch border-b border-neutral-200 py-4"
        >
          <div class="flex shrink grow basis-0 items-center justify-start">
            <h2
              class="shrink grow basis-0 text-sm font-semibold leading-tight text-neutral-700"
            >
              Gold Rates in India
            </h2>
          </div>
        </div>
        <ul class="w-full">
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-lucknow/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Lucknow
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-surat/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Surat
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-bhopal/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Bhopal
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-agra/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Agra
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-ahmedabad/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Ahmedabad
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-amritsar/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Amritsar
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-nagpur/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Nagpur
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-patna/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Patna
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-rajkot/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Rajkot
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-jaipur/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Jaipur
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-meerut/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Meerut
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-chandigarh/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Chandigarh
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-jalgaon/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Jalgaon
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-gurgaon/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Gurgaon
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-guwahati/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Guwahati
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-thane/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Thane
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-aurangabad/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Aurangabad
              </h3></a
            >
          </li>
          <li
            class="w-full self-stretch border-b border-b-gray-accent2 py-4 last:border-none"
          >
            <a
              class="flex w-full justify-between self-stretch text-gray-accent3"
              target="_blank"
              href="/gold-rates/gold-rates-in-nashik/"
              ><h3
                class="py-1 font-medium text-gray-dark underline-animation gray-underline text-[16px]"
              >
                Gold Rates in Nashik
              </h3></a
            >
          </li>
        </ul>
      </div>
      <div
        class="mt-4 inline-flex flex-col items-start justify-start md:mt-0 md:py-4"
      >
        <div
          class="inline-flex items-center justify-start gap-4 self-stretch border-b border-grey-7 py-4"
        >
          <h2 class="shrink grow basis-0 text-sm font-semibold text-grey-8">
            Top 5 Gold ETFs
          </h2>
        </div>
        <div
          class="inline-flex items-start justify-start gap-4 self-stretch border-b border-grey-7 py-4"
        >
          <div class="text-sm font-normal text-grey-8">
            NIP IND ETF GOLD BEES
          </div>
          <div class="shrink grow basis-0 text-right">
            <span class="text-sm font-semibold text-dark-6">₹<!-- -->71.09</span
            ><span class="text-sm font-normal text-error-8">
              <!-- -->(<!-- -->-1.10<!-- -->%)</span
            >
          </div>
        </div>
        <div
          class="inline-flex items-start justify-start gap-4 self-stretch border-b border-grey-7 py-4"
        >
          <div class="text-sm font-normal text-grey-8">
            ICICI PRUDENTIAL GOLD ETF
          </div>
          <div class="shrink grow basis-0 text-right">
            <span class="text-sm font-semibold text-dark-6">₹<!-- -->73.30</span
            ><span class="text-sm font-normal text-error-8">
              <!-- -->(<!-- -->-0.73<!-- -->%)</span
            >
          </div>
        </div>
        <div
          class="inline-flex items-start justify-start gap-4 self-stretch border-b border-grey-7 py-4"
        >
          <div class="text-sm font-normal text-grey-8">HDFC GOLD ETF</div>
          <div class="shrink grow basis-0 text-right">
            <span class="text-sm font-semibold text-dark-6">₹<!-- -->73.32</span
            ><span class="text-sm font-normal text-error-8">
              <!-- -->(<!-- -->-0.99<!-- -->%)</span
            >
          </div>
        </div>
        <div
          class="inline-flex items-start justify-start gap-4 self-stretch border-b border-grey-7 py-4"
        >
          <div class="text-sm font-normal text-grey-8">KOTAK GOLD ETF</div>
          <div class="shrink grow basis-0 text-right">
            <span class="text-sm font-semibold text-dark-6">₹<!-- -->71.58</span
            ><span class="text-sm font-normal text-error-8">
              <!-- -->(<!-- -->-0.95<!-- -->%)</span
            >
          </div>
        </div>
        <div
          class="inline-flex items-start justify-start gap-4 self-stretch border-b border-grey-7 py-4 border-none"
        >
          <div class="text-sm font-normal text-grey-8">SBI-ETF GOLD</div>
          <div class="shrink grow basis-0 text-right">
            <span class="text-sm font-semibold text-dark-6">₹<!-- -->73.30</span
            ><span class="text-sm font-normal text-error-8">
              <!-- -->(<!-- -->-1.01<!-- -->%)</span
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped lang="scss">

table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
    margin: 0;
}
.after\:content-\[\'\'\]:after{--tw-content:"";content:var(--tw-content)}.first\:rounded-tl-sm:first-child{border-top-left-radius:.125rem}.first\:text-left:first-child{text-align:left}.first\:font-normal:first-child{font-weight:400}.last\:mt-8:last-child{margin-top:2rem}.last\:rounded-tr-sm:last-child{border-top-right-radius:.125rem}.last\:border-none:last-child{border-style:none}.last\:border-b-gray-light:last-child{--tw-border-opacity:1;border-bottom-color:rgb(var(--light-grey)/var(--tw-border-opacity))}.after\:last\:border-none:last-child:after{content:var(--tw-content);border-style:none}.hover\:cursor-pointer:hover{cursor:pointer}.hover\:bg-primary-dark:hover{--tw-bg-opacity:1;background-color:rgb(var(--primary-purple-dark)/var(--tw-bg-opacity))}.hover\:bg-primary-light:hover{--tw-bg-opacity:1;background-color:rgb(var(--primary-purple-light)/var(--tw-bg-opacity))}.hover\:text-breadcrumb-link-hover:hover{--tw-text-opacity:1;color:rgb(var(--breadcrumb-hover-link)/var(--tw-text-opacity))}.focus\:border:focus{border-width:1px}.focus\:border-danger:focus{--tw-border-opacity:1;border-color:rgb(var(--danger)/var(--tw-border-opacity))}.focus\:border-primary-base:focus{--tw-border-opacity:1;border-color:rgb(var(--primary-purple)/var(--tw-border-opacity))}.focus\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.active\:bg-\[\#5A2989\]:active{--tw-bg-opacity:1;background-color:rgb(90 41 137/var(--tw-bg-opacity))}.active\:bg-primary-base2:active{--tw-bg-opacity:1;background-color:rgb(var(--primary-purple-2)/var(--tw-bg-opacity))}.active\:bg-primary-dark2:active{--tw-bg-opacity:1;background-color:rgb(var(--primary-purple-dark-2)/var(--tw-bg-opacity))}.active\:text-white:active{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.disabled\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\:border-primary-base\/50:disabled{border-color:rgb(var(--primary-purple)/.5)}.disabled\:bg-black\/10:disabled{background-color:rgba(0,0,0,.1)}.disabled\:bg-primary-base\/50:disabled{background-color:rgb(var(--primary-purple)/.5)}.disabled\:bg-white:disabled{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.disabled\:text-primary-base\/50:disabled{color:rgb(var(--primary-purple)/.5)}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.data-\[state\=closed\]\:animate-fadeOut[data-state=closed]{animation:fadeOut .3s ease-in}@keyframes slideUp{0%{height:var(--radix-accordion-content-height)}to{height:0}}.data-\[state\=closed\]\:animate-slideUp[data-state=closed]{animation:slideUp .3s cubic-bezier(.87,0,.13,1)}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.data-\[state\=open\]\:animate-fadeIn[data-state=open]{animation:fadeIn .3s ease-out}@keyframes slideDown{0%{height:0}to{height:var(--radix-accordion-content-height)}}.data-\[state\=open\]\:animate-slideDown[data-state=open]{animation:slideDown .3s cubic-bezier(.87,0,.13,1)}@media (min-width:640px){.sm\:mx-0{margin-left:0;margin-right:0}.sm\:my-8{margin-top:2rem;margin-bottom:2rem}.sm\:mb-0{margin-bottom:0}.sm\:mt-0{margin-top:0}.sm\:block{display:block}.sm\:hidden{display:none}.sm\:aspect-\[128\/100\]{aspect-ratio:128/100}.sm\:h-3\/4{height:75%}.sm\:h-9{height:2.25rem}.sm\:h-auto{height:auto}.sm\:max-h-60{max-height:15rem}.sm\:max-h-80{max-height:20rem}.sm\:max-h-\[420px\]{max-height:420px}.sm\:w-72{width:18rem}.sm\:w-9{width:2.25rem}.sm\:w-\[35\%\]{width:35%}.sm\:max-w-none{max-width:none}.sm\:flex-1{flex:1 1 0%}.sm\:basis-\[133\.119px\]{flex-basis:133.119px}.sm\:basis-\[320px\]{flex-basis:320px}.sm\:flex-row{flex-direction:row}.sm\:flex-col{flex-direction:column}.sm\:items-end{align-items:flex-end}.sm\:items-center{align-items:center}.sm\:justify-start{justify-content:flex-start}.sm\:justify-end{justify-content:flex-end}.sm\:justify-between{justify-content:space-between}.sm\:gap-0{gap:0}.sm\:gap-1{gap:.25rem}.sm\:gap-2{gap:.5rem}.sm\:gap-\[17px\]{gap:17px}.sm\:gap-\[3px\]{gap:3px}.sm\:overflow-auto{overflow:auto}.sm\:rounded-2xl{border-radius:1rem}.sm\:border-none{border-style:none}.sm\:px-4{padding-left:1rem;padding-right:1rem}.sm\:pb-0{padding-bottom:0}.sm\:pl-0{padding-left:0}.sm\:pr-0{padding-right:0}.sm\:text-2xl{font-size:1.5rem;line-height:2rem}.sm\:text-\[18px\]{font-size:18px}.sm\:text-base{font-size:1rem;line-height:1.5rem}.sm\:text-sm{font-size:.875rem;line-height:1.25rem}.sm\:text-xl{font-size:1.25rem;line-height:1.75rem}.sm\:text-lighter-black{--tw-text-opacity:1;color:rgb(var(--text-lighter-black)/var(--tw-text-opacity))}.sm\:hover\:bg-\[\#F2ECFD\]:hover{--tw-bg-opacity:1;background-color:rgb(242 236 253/var(--tw-bg-opacity))}.sm\:hover\:text-\[\#6A6A6A\]:hover{--tw-text-opacity:1;color:rgb(106 106 106/var(--tw-text-opacity))}}@media (min-width:768px){.md\:my-0{margin-top:0;margin-bottom:0}.md\:mb-2{margin-bottom:.5rem}.md\:mb-8{margin-bottom:2rem}.md\:mb-\[3\.75rem\]{margin-bottom:3.75rem}.md\:mt-0{margin-top:0}.md\:mt-1{margin-top:.25rem}.md\:mt-2{margin-top:.5rem}.md\:mt-3{margin-top:.75rem}.md\:mt-\[10px\]{margin-top:10px}.md\:mt-\[70px\]{margin-top:70px}.md\:block{display:block}.md\:flex{display:flex}.md\:hidden{display:none}.md\:h-\[50px\]{height:50px}.md\:h-\[60px\]{height:60px}.md\:w-1\/2{width:50%}.md\:w-\[50px\]{width:50px}.md\:w-full{width:100%}.md\:max-w-\[330px\]{max-width:330px}.md\:max-w-\[942px\]{max-width:942px}.md\:translate-y-full{--tw-translate-y:100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.md\:scroll-px-0{scroll-padding-left:0;scroll-padding-right:0}.md\:flex-col{flex-direction:column}.md\:items-start{align-items:flex-start}.md\:items-end{align-items:flex-end}.md\:items-center{align-items:center}.md\:justify-end{justify-content:flex-end}.md\:gap-3{gap:.75rem}.md\:gap-4{gap:1rem}.md\:gap-6{gap:1.5rem}.md\:gap-8{gap:2rem}.md\:rounded-2xl{border-radius:1rem}.md\:border{border-width:1px}.md\:border-b{border-bottom-width:1px}.md\:p-6{padding:1.5rem}.md\:px-0{padding-left:0;padding-right:0}.md\:px-6{padding-left:1.5rem;padding-right:1.5rem}.md\:py-0{padding-top:0;padding-bottom:0}.md\:py-4{padding-top:1rem;padding-bottom:1rem}.md\:py-6{padding-top:1.5rem;padding-bottom:1.5rem}.md\:py-\[6px\]{padding-top:6px;padding-bottom:6px}.md\:pb-8{padding-bottom:2rem}.md\:pt-\[3px\]{padding-top:3px}.md\:text-\[12px\]{font-size:12px}.md\:text-\[16px\]{font-size:16px}.md\:text-\[20px\]{font-size:20px}.md\:text-sm{font-size:.875rem;line-height:1.25rem}.md\:font-bold{font-weight:700}.md\:font-medium{font-weight:500}.md\:font-normal{font-weight:400}.md\:font-semibold{font-weight:600}@media (min-width:768px){.md\:md\:font-semibold{font-weight:600}}}@media (min-width:1024px){.lg\:w-fit{width:-moz-fit-content;width:fit-content}.lg\:gap-10{gap:2.5rem}.lg\:self-end{align-self:flex-end}}@media (min-width:1280px){.xl\:block{display:block}.xl\:flex{display:flex}.xl\:hidden{display:none}}@media (prefers-color-scheme:dark){.dark\:bg-gray-600{--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}}.\[\&_p\]\:text-lg p{font-size:1.125rem;line-height:1.75rem}.\[\&_p\]\:font-semibold p{font-weight:600}.\[\&_td\]\:px-3 td{padding-left:.75rem;padding-right:.75rem}@media (min-width:640px){.sm\:\[\&_td\]\:px-8 td{padding-left:2rem;padding-right:2rem}}.\[\&_th\]\:px-3 th{padding-left:.75rem;padding-right:.75rem}@media (min-width:640px){.sm\:\[\&_th\]\:px-8 th{padding-left:2rem;padding-right:2rem}}
</style>
